/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Scope_TitleInputs */



/**
* | output |
* | --- |
* | "Just this once, or always?" |
*
* @param {Meeting_Scope_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_scope_title = /** @type {((inputs?: Meeting_Scope_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Scope_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alleen deze keer of altijd?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette fois seulement ou à chaque fois ?")
	return /** @type {LocalizedString} */ ("Just this once, or always?")
});